// Module
var code = `<div class="donut-chart"></div> `;
// Exports
export default code;